import { ResponsiveUtils } from "../responsive-utils";

// Workaround to disable body scroll on IOS
// Remember scroll position and add position: fixed to body, on close restore position
let scrollPositionMemory = 0;

const disablePageScroll = (iosDisabled: boolean) => {
    if (!iosDisabled && (ResponsiveUtils.isIos() || ResponsiveUtils.isSafari())) {
        scrollPositionMemory = window.scrollY;
        document.body.style.setProperty("--page-scroll-distance", scrollPositionMemory.toString());
    }

    document.body.classList.add("disable-page-scroll");
};

const enablePageScroll = (iosDisabled: boolean) => {
    document.body.classList.remove("disable-page-scroll");

    if (!iosDisabled && (ResponsiveUtils.isIos() || ResponsiveUtils.isSafari())) {
        document.body.style.removeProperty("--page-scroll-distance");
        window.scrollTo(0, scrollPositionMemory);
        scrollPositionMemory = 0;
    }
};

const getPageScrollY = () => scrollPositionMemory || window.scrollY;

export function usePageScrollService() {
    return {
        disablePageScroll,
        enablePageScroll,
        getPageScrollY,
    };
}
